import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, getConfig } from "../../../../utils";

export const delStaff = createAsyncThunk('delStaff', async (data) => {

    try {
        const res = await axios({

            method: 'DELETE',
            url: getConfig.API_URL + `staff/${data?.id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})
